import { render, staticRenderFns } from "./CaracteristicaList.vue?vue&type=template&id=31645ba6"
import script from "./CaracteristicaList.vue?vue&type=script&lang=js"
export * from "./CaracteristicaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports